import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label, Button } from "reactstrap";
//redux
import { useSelector, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
// actions
import { loginUser, resetError } from "../../store/actions";
// import images
import profile from "assets/images/profile-img.png";
import logo from "assets/images/des/logo.svg";
import PulseLoader from "react-spinners/PulseLoader";

const Login = props => {
  //meta title
  document.title = "Login | Des Counts";
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email(),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser({ username: values.email, password: values.password }, props.history));
    }
  });

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }));
  const { loading } = useSelector(state => ({
    loading: state.Login.loading
  }))

  useEffect(() => {
    console.log(error)
  }, [error]);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to Des Counts.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error && <Alert color="danger">{error}</Alert>}
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="text"
                          disabled={loading}
                          onChange={(e) => {
                            validation.handleChange(e)
                            if (error) { dispatch(resetError("")) }
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <div className="input-group">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter Password"
                            disabled={loading}
                            onChange={(e) => {
                              validation.handleChange(e)
                              if (error) { dispatch(resetError("")) }
                            }}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          <div className="input-group-addon position-absolute" style={{ right: '10px', top: '10px', zIndex: '6' }}>
                            <a onClick={() => {
                              setShowPassword(!showPassword)
                            }}>
                              {
                                !showPassword &&
                                <i className="fas fa-eye-slash"></i>
                              }
                              {
                                showPassword &&
                                <i className="fas fa-eye"></i>
                              }
                            </a>
                          </div>
                        </div>
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-3 d-grid mb-2">
                        <Button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          <div className="d-flex justify-content-center">
                            <PulseLoader loading={loading} color={'#FFF'} size={12} className="align-self-center" />
                          </div>
                          {!loading && <>Log In</>}
                        </Button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} Des Counts. Powered by PakaiKita
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
